import { render, staticRenderFns } from "./EditBatch.vue?vue&type=template&id=52359702&scoped=true&"
import script from "./EditBatch.vue?vue&type=script&lang=js&"
export * from "./EditBatch.vue?vue&type=script&lang=js&"
import style0 from "./EditBatch.vue?vue&type=style&index=0&id=52359702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52359702",
  null
  
)

export default component.exports